module.exports = "/images/vendor/flag-icon-css/flags/4x3/la.svg?0f124ae33af5a9291262592979c90f55";